export default {"src":"/_next/static/media/coin-circle.c0efd0ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};